import type { TablePaginationConfig } from 'antd';
import i18n from '../i18n';

export const DEFAULT_TABLE_PAGINATION: TablePaginationConfig = {
  pageSize: 20,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50', '100'],
  showTotal: (total, range) =>
    i18n.t('common.tableShowTotal', { from: range[0], to: range[1], total }),
};

export const COMPACT_TABLE_PAGINATION: TablePaginationConfig = {
  ...DEFAULT_TABLE_PAGINATION,
  pageSize: 50,
};
